module.exports = __webpack_public_path__ + "assets/img/boy.dbfc60e6.png";